import { devConfig } from "./envConfig/devEnv";
import { previewConfig } from "./envConfig/previewEnv";
import { prodConfig } from "./envConfig/prodEnv";
import { testConfig } from "./envConfig/testEnv";
import { stagingConfig } from "./envConfig/stagingEnv";
import { preProdConfig } from "./envConfig/preProdEnv";
import { swmProdConfig } from "./envConfig/swmProdEnv";
import { swmDevConfig } from "./envConfig/swmDevEnv";
import { orthoEMotionProdConfig } from "./envConfig/orthoEMotionEnv";

export const ENV_CONSTANT = {
  DEV: "dev",
  TEST: "test",
  STAGING: "staging",
  PREVIEW: "preview",
  PROD: "prod",
  ["pre-prod"]: "pre-prod",
  ["integration-dev"]: "integration-dev",
  CANDID: "candid",
  SWM_PROD: "swm-prod",
  SWM_DEV: "swm-dev",
  ORTHO_E_MOTION_PROD: "ortho-e-motion-prod",
};

export const getEnv = () => {
  const env = process.env.REACT_APP_NODE;
  console.log("ENV:", env);
  return env;
};

export const getProcessConfig = () => {
  const env = getEnv();

  const envConfigMap = {
    dev: devConfig,
    test: testConfig, // current not use
    staging: stagingConfig,
    preview: previewConfig,
    prod: prodConfig,
    ["pre-prod"]: preProdConfig,
    ["integration-dev"]: devConfig,
    ["integration-preview"]: previewConfig,
    ["integration-prod"]: prodConfig,
    ["swm-prod"]: swmProdConfig,
    ["swm-dev"]: swmDevConfig,
    [ENV_CONSTANT.ORTHO_E_MOTION_PROD]: orthoEMotionProdConfig,
  };

  const config = envConfigMap[env];

  if (!config) {
    return envConfigMap["preview"];
  }

  return config;
};

export const processConfig = {
  env: getProcessConfig(),
};

export const isSWM = () => {
  const env = getEnv();
  return env === ENV_CONSTANT.SWM_PROD || env === ENV_CONSTANT.SWM_DEV;
};

export const SupportShowShortcutKeyView = () => {
  const env = getEnv();
  return (
    env === ENV_CONSTANT.DEV ||
    env === ENV_CONSTANT.PREVIEW ||
    env === ENV_CONSTANT.PROD
  );
};
